import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountService } from '@arkius/shared-api';

const routes: Routes = [
  {
    path: '',
    resolve: {
      profile: () => inject(AccountService).apiV5AccountProfileGet(),
    },
    loadChildren: () =>
      import('./pages/main/main.module').then((m) => m.MainPageModule),
  },
  {
    path: 'create',
    loadChildren: () =>
      import('../../../mobile/src/app/create/create.module').then(
        (m) => m.CreatePageModule,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('../../../mobile/src/app/auth/auth.module').then(
        (m) => m.AuthPageModule,
      ),
  },
  {
    path: 'main',
    resolve: {
      profile: () => inject(AccountService).apiV5AccountProfileGet(),
    },
    loadChildren: () =>
      import('./pages/main/main.module').then((m) => m.MainPageModule),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('../../../mobile/src/app/public/public.module').then(
        (m) => m.PublicPageModule,
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
